import gql from 'graphql-tag';

export default gql`
  mutation updateAMEthnicDiversities($input: updateAMEthnicDiversitiesInput!) {
    updateAMEthnicDiversities(input: $input) {
      defaults {
        version
        ethnicDiversities
      }
    }
  }
`;
